﻿import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import * as React from 'react';

type FilterHiddenOrderCheckboxProps = {
    isChecked: boolean;
    onChange: () => void;
    label: string;
};

const SHOW_HIDDEN_ORDERS = 'show-hidden-orders';

export function FilterHiddenOrderCheckbox({
    isChecked,
    onChange,
    label
}: FilterHiddenOrderCheckboxProps) {
    function handleClick() {
        if (typeof onChange === 'function') {
            onChange();
        }
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Checkbox
                inputProps={{ 'aria-label': 'mui checkbox' }}
                id={SHOW_HIDDEN_ORDERS}
                name={SHOW_HIDDEN_ORDERS}
                onClick={handleClick}
                checked={isChecked}
            />
            <label htmlFor={SHOW_HIDDEN_ORDERS} style={{ margin: 'unset', cursor: 'pointer' }}>
                {label}
            </label>
        </Box>
    );
}
